import { ApolloLink } from "@apollo/client";
import createSplitLink from "./createSplitLink";
const V1_GRAPHQL_TAG = 'gql';
const V2_GRAPHQL_TAG = 'graphql';
const splitOverriddenOperations = (overriddenOperationsV1ToV2)=>(operation)=>operation.getContext().queryTag === V1_GRAPHQL_TAG && overriddenOperationsV1ToV2[operation.operationName];
export default function createOverriddenV1ToV2Link(graphqlConfig) {
    var _graphqlConfig_schemas_V2_GRAPHQL_TAG;
    const v2Link = (_graphqlConfig_schemas_V2_GRAPHQL_TAG = graphqlConfig.schemas[V2_GRAPHQL_TAG]) === null || _graphqlConfig_schemas_V2_GRAPHQL_TAG === void 0 ? void 0 : _graphqlConfig_schemas_V2_GRAPHQL_TAG.apolloLink;
    const overriddenOperationsV1ToV2 = graphqlConfig.unstable_overriddenOperationsV1ToV2 || {};
    return v2Link ? ApolloLink.split(splitOverriddenOperations(overriddenOperationsV1ToV2), v2Link, createSplitLink(graphqlConfig)) : createSplitLink(graphqlConfig);
}

//# sourceMappingURL=createOverriddenV1ToV2Link.js.map